<template>
  <div>
    <c-card title="국소배기장치 목록 업로드 (동일한 공정또는작업장명 자료가 수정됩니다.)" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn 
            v-if="editable" 
            label="LBLAPPLY" 
            icon="save"
            @btnClicked="acceptData" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-3">
          <c-plant :editable="false" type="edit" name="plantCd" v-model="data.plantCd" />
        </div>
      </template>
    </c-card>
    <c-excel-upload 
      :editable="editable"
      :excelUploadInfo="excelUploadInfo"
    />
  </div>
</template>

<script>
export default {
  name: 'device-equipment-excel-upload',
  data() {
    return {
      data: {
        plantCd: null,  // 사업장코드
      },
      headerUrl: '',
      excelUploadInfo: {
        rowKeys: ['processName'], // 데이터들의 키 속성값
        taskClassCd: 'PSI_LOCAL_EXHOUST_UPLOAD', // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [[
          {
            name: 'plantCd',
            label: '사업장',
            align: 'center',
            style: 'width:110px',
            type: 'plant',
            sortable: false,
          },
          {
            name: 'processName',
            field: 'processName',
            // 공정또는작업장명
            label: 'LBL0010609',
            style: 'width:150px',
            align: 'left',
            sortable: false,
          },
          {
            name: 'inOutFlag',
            field: 'inOutFlag',
            // 실내외구분
            label: 'LBL0010570',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'sourceName',
            field: 'sourceName',
            // 발생원
            label: 'LBL0010571',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'harmfulTypeCd',
            field: 'harmfulTypeCd',
            // 유해물질종류
            label: 'LBL0010572',
            style: 'width:120px',
            align: 'center',
            sortable: false,
            fix: true,
          },
          {
            name: 'hoodForm',
            field: 'hoodForm',
            // 후드형식
            label: 'LBL0010573',
            align: 'center',
            style: 'width:120px',
            sortable: false,
            fix: true,
          },
          {
            name: 'hoodVelocity',
            field: 'hoodVelocity',
            // 후드의제어풍속(m/s)
            label: 'LBL0010574',
            style: 'width:120px',
            align: 'center',
            sortable: false,
          },
          {
            name: 'reactionVelocity',
            field: 'reactionVelocity',
            // 덕트내반응속도(m/s)
            label: 'LBL0010575',
            style: 'width:120px',
            align: 'center',
            sortable: false,
          },
          {
            name: 'airVolume',
            field: 'airVolume',
            // 배풍량(㎥/min)
            label: 'LBL0010576',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'motorVolume',
            field: 'motorVolume',
            // 전동기용량(Kw)
            label: 'LBL0010577',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'motorExplosionForm',
            field: 'motorExplosionForm',
            // 전동기방폭형식
            label: 'LBL0010578',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'airCleanType',
            field: 'airCleanType',
            // 공기정화장치형식
            label: 'LBL0010579',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'airExhaustOrder',
            field: 'airExhaustOrder',
            // 배기및처리순서
            label: 'LBL0010580',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'deptName',
            label: '관리부서명',
            deptCd: 'deptCd',
            align: 'center',
            style: 'width:250px',
            type: 'dept',
            sortable: false,
          },
        ]],
        data: [],
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (!this.excelUploadInfo.data[0] || this.excelUploadInfo.data[0].length === 0) {
          dataCntCheck = false;
        }
        if (this.$_.findIndex(this.excelUploadInfo.data[0], (item) => { return item.error_message }) > -1) {
          errorDataCheck = true
        }

        if (!dataCntCheck) {
          window.getApp.$emit('ALERT', {
            title: 'LBLGUIDE', // 안내
            message: '업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.', // 업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.
            type: 'warning', // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit('ALERT', {
              title: 'LBLGUIDE', // 안내
              message: '에러가 있는 데이터가 존재합니다.\n\r데이터 확인 후 적용하시길 바랍니다.', // 업로드할 데이터가 없는 Sheet가 있습니다.\n\r데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.
              type: 'warning', // success / info / warning / error
            });
          } else {
            window.getApp.$emit('CONFIRM', {
              title: 'LBLCONFIRM',
              message: '해당 엑셀데이터를 업로드하면,\n\r동일한 공정또는작업장명 자료가 수정됩니다 \n\r그대로 적용하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수  
              confirmCallback: () => {
                this.$emit('closePopup', this.excelUploadInfo.data[0]);
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        }
      }
    }
  }
};
</script>
